import React, { useMemo, useState } from 'react';
import { Modal, ModalProps } from '@vimily/bonjoro-ui-components-v2/Modal';
import { useGlobalEvent } from 'beautiful-react-hooks';
import { s3Asset } from '~/helpers';

export const openWhatAreCustomFieldsModalEventName =
  'what-are-custom-fields::open';

export const openWhatAreCustomFieldsModal = () =>
  window.dispatchEvent(new CustomEvent(openWhatAreCustomFieldsModalEventName));

export const WhatAreCustomFieldsModal = () => {
  const [open, setOpen] = useState(false);

  const onOpenWhatAreCustomFieldsModal = useGlobalEvent(
    openWhatAreCustomFieldsModalEventName as keyof WindowEventMap
  );

  onOpenWhatAreCustomFieldsModal(() => setOpen(true));

  const closeModal = () => {
    setOpen(false);
  };

  const modalProps = useMemo<ModalProps>(() => {
    return {
      open,
      onModalClose: closeModal,
      className: 'max-w-[750px] !p-8',
      overlayClassName: 'p-8 !z-[9999999999]',
      closeButtonClassName: '!w-5',
    };
  }, [open]);

  return (
    <Modal {...modalProps}>
      <div className='text-[28px] text-neutral-900 font-bold'>
        What are custom fields?
      </div>
      <div className='flex flex-col gap-y-3 mt-5'>
        <span>
          Connect Bonjoro to your existing tech stack and use custom fields to
          truly personalise your Bonjoros by bringing in the customer
          information that is most important to you.
        </span>
        <span>
          Custom Fields will take a snap shot of the most up to date data in
          your system at the time your task is created and put it on display for
          you to check before and while recording so you can reference these in
          your message.
        </span>
        <a
          href='https://help.bonjoro.com/en/articles/2709183-personalise-your-video-messages-at-scale-with-crm-data-using-custom-variables'
          target='_blank'
          rel='noreferrer'
          className='text-base text-neutral-500 underline underline-offset-4 hover:text-neutral-900'
        >
          Learn more about custom fields here.
        </a>
      </div>
      <img
        src={s3Asset('/assets/modals/what-are-custom-fields.png')}
        className='max-w-full mt-5'
      />
    </Modal>
  );
};
